export const TESTIMONIALS_CONTENT = {
  eyebrow: 'Testimonials',
  heading: 'What Our Partners Say',
  subheading: 'Real feedback from the agencies and operators who trust us on the ground.',
};

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Priya Nair',
    role: 'Founder, Wanderlust Travels',
    country: 'India',
    rating: 5,
    review:
      'Every itinerary they build lands exactly as planned. Our clients come back talking about experiences we could never have arranged on our own.',
  },
  {
    id: 2,
    name: 'Marco Bellini',
    role: 'Managing Director, Bellini Voyages',
    country: 'Italy',
    rating: 5,
    review:
      'A ground partner that behaves like an extension of our own team. Communication is fast, and nothing ever falls through the cracks.',
  },
  {
    id: 3,
    name: 'Sarah Thompson',
    role: 'Independent Traveller',
    country: 'United Kingdom',
    rating: 5,
    review:
      'Our two weeks in Vietnam felt entirely personal. The small details made all the difference.',
  },
  {
    id: 4,
    name: 'Kenji Tanaka',
    role: 'CEO, East Meet West Travel',
    country: 'Japan',
    rating: 5,
    review:
      'Their local knowledge of Vietnam is unmatched. Every recommendation has been spot-on for our luxury clientele.',
  },
  {
    id: 5,
    name: 'Emma Laurent',
    role: 'Tour Operator, Voyages ML',
    country: 'France',
    rating: 5,
    review:
      'We have been partnering for three years and the consistency in quality keeps improving. Truly professional.',
  },
  {
    id: 6,
    name: 'David Chen',
    role: 'Director, Asia Routes',
    country: 'Singapore',
    rating: 5,
    review:
      'The logistics are seamless — transfers, guides, permits. It lets us focus on selling rather than troubleshooting.',
  },
  {
    id: 7,
    name: 'Anna Schmidt',
    role: 'Travel Designer, Globe Trotter',
    country: 'Germany',
    rating: 5,
    review:
      'Our groups receive nothing but praise for the accommodation and dining choices. Excellent curation.',
  },
  {
    id: 8,
    name: 'James O\'Brien',
    role: 'Owner, Emerald Tours',
    country: 'Ireland',
    rating: 5,
    review:
      'Responsive, reliable, and resourceful. They handled a last-minute change during peak season without a hitch.',
  },
  {
    id: 9,
    name: 'Linh Nguyen',
    role: 'Marketing Head, Vietnam Explore',
    country: 'Vietnam',
    rating: 5,
    review:
      'As a local partner they go above and beyond for every group. The attention to detail is remarkable.',
  },
  {
    id: 10,
    name: 'Olivia Park',
    role: 'Founder, Silk Road Travels',
    country: 'South Korea',
    rating: 5,
    review:
      'The cultural immersion experiences they arrange are the highlight of every itinerary. Our guests rave about them.',
  },
];
